import React from "react";
import { motion } from "framer-motion";

export default function IndustriesSection() {
  const industries = [
    {
      icon: "🛒",
      title: "E-Commerce & Retail",
      description: "Online stores, inventory systems, and AI product recommendations that boost sales.",
    },
    {
      icon: "🏥",
      title: "Healthcare & Clinics",
      description: "Appointment systems, patient portals, and secure, compliant digital tools.",
    },
    {
      icon: "🎓",
      title: "Education & E-Learning",
      description: "Learning platforms, course apps, and interactive tools that engage students.",
    },
    {
      icon: "🚀",
      title: "Startups & SaaS",
      description: "MVPs, scalable products, and AI features to launch fast and grow smart.",
    },
    {
      icon: "🏦",
      title: "Finance & Fintech",
      description: "Dashboards, payment integrations, and automation for secure financial workflows.",
    },
    {
      icon: "🎮",
      title: "Gaming & Entertainment",
      description: "Multiplayer games, real-time systems, and immersive interactive experiences.",
    },
    {
      icon: "🏭",
      title: "Manufacturing & Logistics",
      description: "Inventory tracking, process automation, and smart dashboards for operations.",
    },
    {
      icon: "🍽️",
      title: "Food & Hospitality",
      description: "Ordering apps, booking systems, and customer engagement tools that drive repeat business.",
    },
  ];

  return (
    <section className="industries" id="industries">
      <h2>Industries We Serve</h2>
      <p className="section-subtitle">
        We understand what each industry needs to succeed
      </p>

      <div className="industries-grid">
        {industries.map((item, i) => (
          <motion.div
            key={item.title}
            className="industry-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: (i % 4) * 0.1, duration: 0.5 }}
            whileHover={{ y: -8 }}
          >
            <div className="industry-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </motion.div>
        ))}
      </div>

      <motion.p
        className="industries-note"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
        Don't see your industry? We work with all kinds of businesses.{" "}
        <a href="#contact">Let's talk</a>.
      </motion.p>
    </section>
  );
}
